// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1V7hk","productName":"Table_productName__313Rf"};